/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const loopFieldValueSchema = z.object({
  id: z.int(),
  isMapped: z.boolean(),
  name: z.string(),
});
